import "./Home.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import {
  reactPlugin,
} from "../../../../services/appInsights.service";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { TesterService } from "../../../../services/tester.service";
import { Tester } from "../../../../interfaces/tester.interface";
import TesterCard from "../../appSubComponents/testerCard/TesterCard";
import { Button, Form, FormControl } from "react-bootstrap";
import { Plus, Search } from "react-bootstrap-icons";
import Spinner from "../../../components/Spinner";
import ComponentModel from "../../appUtilityComponent/ComponentModel/ComponentModel";
import { ComponentModelPopup } from "../../../../interfaces/modal.interface";
import {
  UserAuthContext,
  Authorize,
} from "../../appLoginComponent/UserAuthContext";
import { UserInfo } from "../../../../interfaces/userInfo.interafce";
import NotAuthorized from '../../appLoginComponent/NotAuthorized';
type TParams = Readonly<{ currentUser: UserInfo }>;

function Home({ currentUser }: TParams) {
  let { isAuthorized } = useContext(
    UserAuthContext
  ) as Authorize;

  let [testers, setTesters] = useState([] as Tester[]);

  let [isShowLoading, setIsShowLoading] = useState(false as boolean);

  const [searchTerm, setSearchTerm] = useState("" as string);

  let [errorModal, setErrorModal] = useState({
    Title: "Error",
    Show: false,
    Component: null,
    HandleClose: () => setErrorModal({ ...errorModal, Show: false })
  } as ComponentModelPopup);

  let navigate = useNavigate();

  useEffect(() => {
    const url = sessionStorage.getItem("avirpfg_redirectURL");

    if (url && url !== 'undefined' && url !== 'null') {
      navigate(url);
      sessionStorage.removeItem("avirpfg_redirectURL");
      return;
    }

    setIsShowLoading(true);
    let testerService = new TesterService();

    testerService.GetAllTesters().then((response) => {
      if (response.statusCode === "N") {
        const errorMessage = response.statusMessage || "Failed to load testers";
        console.error("GetAllTesters error:", errorMessage);
        setErrorModal({
          Title: "Error",
          Show: true,
          Component: <div>{errorMessage}</div>,
          HandleClose: () => setErrorModal({ ...errorModal, Show: false })
        });
        setIsShowLoading(false);
        return;
      }
      setTesters(response.result || []);
      setIsShowLoading(false);
    }).catch((error: any) => {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while loading testers";
      console.error("GetAllTesters exception:", error);
      setErrorModal({
        Title: "Error",
        Show: true,
        Component: <div>{message}</div>,
        HandleClose: () => setErrorModal({ ...errorModal, Show: false })
      });
      setIsShowLoading(false);
    });
  }, []);

  const onsubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <>
      <ComponentModel modal={errorModal} />
      {isAuthorized("AV_LandingPage") ? (
        <div className="page-container">
          <div className="row animation-content mt-3">
            <div className="col-sm-12">
              <div className="row mb-4">
                <div className="col text-left">
                  <Button
                    className="pr-2 btn-tester-add btn-icon cursor-shadow-sm"
                    variant="light"
                    as={NavLink as any}
                    to="/tester/0"
                  >
                    <div className="btn-white-icon float-left hw-54">
                      <Plus
                        className="float-left btn-tester-add-icon secondary-icon"
                        size={60}
                      />
                    </div>
                    <div className="d-flex w-100 justify-content-center">


                      <div className="btn-tester-add-text inline">
                        Add New Tester
                      </div>
                    </div>
                  </Button>
                </div>
                <div className="col text-right">
                  <Form
                    className="input-group form-tester-search float-right d-flex"
                    onSubmit={onsubmit}
                  >
                    <FormControl
                      className="formcontrol-tester-search"
                      type="text"
                      placeholder="Search"
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span className="input-group-append">
                      <Button
                        className="btn-tester-search"
                        type="submit"
                        value="Submit"
                        variant="primary"
                      >
                        <Search
                          color="#fff"
                          className="mr-2 float-right btn-tester-add-icon"
                          size={24}
                        />
                      </Button>
                    </span>
                  </Form>
                </div>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="row">
                {testers.some(
                  (x) =>
                    x.isActive === "Y" &&
                    (x.testerName
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                      x.pddsCount
                        .toString()
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                      (x.automatedVehiclesCount + x.pddsCount)
                        .toString()
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()))
                ) ? (
                  testers
                    .filter(
                      (x) =>
                        x.isActive === "Y" &&
                        (x.testerName
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase()) ||
                          x.pddsCount
                            .toString()
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()) ||
                          (x.automatedVehiclesCount + x.pddsCount)
                            .toString()
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()))
                    )
                    .map((tester: Tester) => (
                      <div
                        key={tester.testerId}
                        className="col-xxl-4 col-xl-6 col-md-12"
                      >
                        <TesterCard tester={tester}></TesterCard>
                      </div>
                    ))
                ) : (
                  <div className="col-sm-12 text-left">No Testers Found</div>
                )}
              </div>
            </div>
          </div>
          {isShowLoading && <Spinner></Spinner>}
        </div>
      ) : (
        <NotAuthorized />
      )}
    </>
  );
}

//}

export default withAITracking(reactPlugin, Home);
